import type { ComponentProps, FC } from 'react';

import { AccordionTrigger } from '@repo/ui/components/common';
import { cn } from '@repo/utils/common';

interface SipAccordionTriggerProps extends ComponentProps<typeof AccordionTrigger> {
  className?: string;
}

export const SipAccordionTrigger: FC<SipAccordionTriggerProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <AccordionTrigger
      className={cn(
        'text-primary cursor-pointer px-4',
        'data-[state=open]:bg-primary data-[state=open]:text-primary-foreground data-[state=open]:[&_svg]:text-primary-foreground',
        className,
      )}
      {...props}
    >
      {children}
    </AccordionTrigger>
  );
};
